<template>
    <price-tag-shell :context="context" variant="split">
        <div class="split">
            <div class="split__left pt-column">
                <div class="pt-headline">{{ tagText('save') }}</div>
                <div class="pt-big-number">
                    <template v-if="editable">
                        <price-tag-value v-bind="bindField('percent')" />%
                    </template>
                    <template v-else>{{ formatPercent(firstTier.discountPercent) }}</template>
                </div>
                <div v-if="context.regularPrice" class="pt-medium pt-strike">
                    {{
                        tagText('was', {
                            price: formatMoney(context.regularPrice),
                            currency: context.currencySymbol,
                        })
                    }}
                </div>
            </div>
            <div class="split__right pt-column pt-grow">
                <price-tag-product :product="context.product" size="medium" />
                <div class="pt-row">
                    <span class="pt-big-number">{{ formatMoney(firstTier.promoPrice) }}</span>
                    <span class="pt-currency">{{ context.currencySymbol }}</span>
                </div>
                <div v-if="editable || hasDeposit" class="pt-small">
                    <template v-if="editable">
                        {{ tagText('depositLabel') }}
                        <price-tag-value v-bind="bindField('deposit')" />
                        {{ context.currencySymbol }}
                    </template>
                    <template v-else>
                        {{
                            tagText('deposit', {
                                deposit: formatMoney(values.deposit),
                                currency: context.currencySymbol,
                            })
                        }}
                    </template>
                    <template v-if="hasDeposit && totalPrice !== null">
                        &nbsp;·&nbsp;
                        {{
                            tagText('total', {
                                total: formatMoney(totalPrice),
                                currency: context.currencySymbol,
                            })
                        }}
                    </template>
                </div>
            </div>
        </div>
    </price-tag-shell>
</template>

<script setup>
import { computed } from 'vue';
import { isNil } from 'lodash';
import {
    priceTagLayoutProps,
    priceTagLayoutEmits,
    usePriceTagLayout,
} from '@/js/composables/usePriceTagLayout';

const props = defineProps(priceTagLayoutProps);
const emit = defineEmits(priceTagLayoutEmits);

const { bindField, tagText, formatMoney, formatPercent } = usePriceTagLayout(props, emit);

const firstTier = computed(() => props.context.tiers[0] || {});

const hasDeposit = computed(() => !isNil(props.values.deposit) && props.values.deposit !== '');

const totalPrice = computed(() =>
    isNil(firstTier.value.promoPrice) ? null : firstTier.value.promoPrice + props.values.deposit
);
</script>

<style lang="scss" scoped>
@import '@style/price-tags/price-tag-layout';

.split {
    display: flex;
    flex: 1;

    &__left {
        width: 18rem;
        padding: 1.6rem;
        background: var(--price-tag-split-background);
        color: var(--price-tag-split-highlight);
    }

    &__right {
        padding: 1.6rem;
    }
}
</style>
